export default {
  materialSelected: null,
};
